'user strict';
angular.module('modifyChartInfoModule', [])
    .controller('modifyChartInfoCtrl', ['$scope', '$modalInstance', '$interval', '$validation', 'item', 'trsHttpService', 'modalDialog', function($scope, $modalInstance, $interval, $validation, item, trsHttpService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                chartInfos: {
                    // chartNum: item.info
                },
                step: 1,
                time: 60,
                sendable: true,
                sendNewable: true,
                sendCodeParams: {},
                emailTip: false
            };
            $scope.data = {};
            if (item.type === 'tel') {
                $scope.status.sendCodeParams = {
                    serviceid: 'mlf_tenantuploadmanage',
                    methodname: 'sendSMScode'
                };
                $scope.status.checkCodeParams = {
                    serviceid: 'mlf_tenantuploadmanage',
                    methodname: 'checkSMSCode',
                };
                $scope.status.chartInfos.chartWay = '手机号';
                $scope.status.chartInfos.chartNum = item.info.MOBILE;
            } else if (item.type === 'loginName') {
                $scope.status.chartInfos.chartWay = '用户名';
                $scope.status.chartInfos.chartNum = item.info.LOGINACCOUNTNAME;
                $scope.data.newLoginName = item.info.LOGINACCOUNTNAME;
                $scope.status.step = 2;
            } else {
                $scope.status.sendCodeParams = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'ResetPassToEmail'
                };
                $scope.status.checkCodeParams = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'checkSMSCode',
                };
                $scope.status.chartInfos.chartWay = '邮箱';
                $scope.status.chartInfos.chartNum = item.info.EMAIL;
            }
            $scope.$on('destroy', function() {
                $interval.cancel($scope.times);
            });
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (item.type !== 'loginName') {
                sendCode();
            }
        }

        /**
         * [countDown description] 倒计时
         * @return {[type]} [description]
         */
        function countDown() {
            $scope.timer = $interval(function() {
                if ($scope.status.time > 0) {
                    $scope.status.time--;
                } else {
                    $interval.cancel($scope.timer);
                    $scope.status.sendable = true;
                    $scope.status.sendNewable = true;
                    $scope.status.emailTip = false;
                }
            }, 1000);
        }

        /**
         * [sendCode description] 重新发送验证码
         * @return {[type]} [description]
         */
        function sendCode() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.sendCodeParams, 'get').then(function(data) {
                if (data.ISSUCCESS) {
                    $scope.status.time = item.type == 'email' ? 3 : 60;
                    $scope.status.sendable = false;
                    $scope.status.emailTip = true;
                    countDown();
                }
            });
        }
        $scope.sendCode = sendCode;

        /**
         * [next description] 跳转到填写新信息
         * @return {Function} [description]
         */
        $scope.next = function() {
            $validation.validate($scope.formOne).success(function() {
                $scope.status.checkCodeParams.SMSCODE = $scope.data.codeOne;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.checkCodeParams, 'get').then(function(data) {
                    if (data.ISSUCCESS) {
                        $scope.status.step = 2;
                        $interval.cancel($scope.timer);
                    }
                });
            });

        };

        /**
         * [getNewCode description] 获取新号码的验证码
         * @return {[type]} [description]
         */
        $scope.getNewCode = function() {
            if ($scope.status.chartInfos.chartWay === '手机号') {
                $validation.validate($scope.formTwo.newTel).success(function() {
                    getMessage();
                });
            } else {
                $validation.validate($scope.formTwo.newEmail).success(function() {
                    getMessage();
                });
            }

            /**
             * [getMessage 获取信息]
             *
             * @return  {[type]}  [return description]
             */
            function getMessage() {
                if ($scope.status.chartInfos.chartWay === '手机号') {
                    $scope.status.sendCodeParams.MOBILENUM = $scope.data.newTel;
                } else {
                    $scope.status.sendCodeParams.EMAIL = $scope.data.newEmail;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.sendCodeParams, 'get').then(function(data) {
                    if (data.ISSUCCESS) {
                        $scope.status.time = item.type == 'email' ? 3 : 60;
                        $scope.status.sendable = false;
                        $scope.status.sendNewable = false;
                        countDown();
                    }
                });
            }
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close();
        };

        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.formTwo).success(function() {
                if (item.type !== 'loginName') {
                    $scope.status.checkCodeParams.SMSCODE = $scope.data.newCode;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.checkCodeParams, 'get').then(function(data) {
                        if (data.ISSUCCESS) {
                            saveModifyInfo();
                        }
                    });
                } else {
                    saveModifyInfo();
                }
            });
        };

        /**
         * [saveModifyInfo 保存修改后的信息]
         *
         * @return  {[type]}  [return description]
         */
        function saveModifyInfo() {
            var params = angular.copy(item.info);
            var tip = $scope.status.chartInfos.chartWay + '修改成功';
            if ($scope.status.chartInfos.chartWay === '手机号'){
                params.MOBILE = $scope.status.sendCodeParams.MOBILENUM; 
            } else if ($scope.status.chartInfos.chartWay === '用户名') {
                params.LOGINACCOUNTNAME = $scope.data.newLoginName;
            } else {
                params.EMAIL = $scope.status.sendCodeParams.EMAIL;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                modalDialog.alertType(tip, '', 'success', false);
                $modalInstance.close();
            });
        }

        /**
         * [checkUserName 校验用户名 已经是使用则不能使用]
         *
         * @param   {[type]}  isLoginName  [isLoginName 是否为检查登录用户名]
         *
         * @return  {[type]}               [return description]
         */
        $scope.checkUserName = function(isLoginName) {
            if (!$scope.data.newLoginName) {
                return;
            }
            var params = {
                serviceid: 'mlf_usermanagement',
                methodname: 'checkUserName',
                UERNAME: item.info.USERNAME,
                USERID: item.info.USERID == 0 ? '' : item.info.USERID,
            };
            if (isLoginName) {
                params.USERATTR = 'LOGINACCOUNTNAME';
                params.UERNAME = $scope.data.newLoginName;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.TYPE != '3') {
                    if (isLoginName) {
                        $scope.repeatLOGINACCOUNTNAME = true;
                    } else {
                        $scope.repeatName = true;
                    }
                } else {
                    if (isLoginName) {
                        $scope.repeatLOGINACCOUNTNAME = false;
                    } else {
                        $scope.repeatName = false;
                    }
                }
            });
        };
        $scope.changeRepeatName = function(isLoginName) {
            if (isLoginName) {
                $scope.repeatLOGINACCOUNTNAME = false;
            } else {
                $scope.repeatName = false;
            }
        };
    }]);
